interface NotificationDetail {
  message: string;
  type: 'success' | 'error' | 'info';
}

/**
 * Dispatches a custom event to show a notification banner.
 * @param {string} message The message to display.
 * @param {'success' | 'error' | 'info'} [type='error'] The type of notification.
 */
export function dispatchNotification(message: string, type: 'success' | 'error' | 'info' = 'error') {
  const event = new CustomEvent<NotificationDetail>('show-notification', {
    detail: { message, type },
  });
  window.dispatchEvent(event);
}

/**
 * Initializes global error handlers to catch and display unhandled errors.
 */
export function initErrorHandling() {
  // Catches unhandled synchronous errors
  window.addEventListener('error', (event: ErrorEvent) => {
    console.error('Unhandled synchronous error:', event.error);
    dispatchNotification('An unexpected error occurred. Please try refreshing the page.');
    // Prevent the default browser error handler
    event.preventDefault();
  });

  // Catches unhandled promise rejections
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    console.error('Unhandled promise rejection:', event.reason);
    
    let message = 'An unexpected error occurred. Please check the console for details.';
    
    // Check for common Firebase/network errors
    if (event.reason instanceof Error) {
        if (event.reason.message.includes('network') || event.reason.message.includes('Failed to fetch')) {
            message = 'A network error occurred. Please check your connection.';
        } else if (event.reason.message.includes('permission-denied') || event.reason.message.includes('PERMISSION_DENIED')) {
            message = 'Permission denied. You may not have access to this resource.';
        }
    }

    dispatchNotification(message);
    // Prevent the default browser error handler
    event.preventDefault();
  });

  console.log('Global error handlers initialized.');
}
